// extracted by mini-css-extract-plugin
export var notificationHost = "_ke-0";